(function () {
  "use strict";

  angular.module("sempraWebapp").component("singleWash", {
    templateUrl: "app/pricing/singleWash/singleWash.component.html",
    controller: singleWashController,
    bindings: {
      singleWashData: "<",
      regionCurrency: "<",
      onCreate: "&"
    },
    controllerAs: "vm"
  });

  function singleWashController($scope, $translate, pricingActions) {
    var vm = this;

    $scope.saveButtonClass = "md-primary";

    vm.singleWashData = {};
    vm.singleWashList = [];
    vm.editSingleWash = false;
    vm.deleteSingleWash = false;
    vm.buttonTitle = $translate.instant("SAVE");

    vm.$onChanges = function (changes) {
      if (changes.singleWashData) {
        vm.singleWashList = changes.singleWashData.currentValue;
      } else if (changes.regionCurrency) {
        vm.regionCurrency = changes.regionCurrency.currentValue;
      } else {
        return;
      }
    };

    vm.save = function (singleWashData) {
      var data = {
        id: singleWashData.id,
        price: singleWashData.price
      };
      if (vm.editSingleWash) {
        updateSingleWashData(data);
      } else if (vm.deleteSingleWash) {
        deleteSingleWashData(data);
      } else {
        saveSingleWashData(data);
      }
    };

    function saveSingleWashData(data) {
      pricingActions.createSingeWash(data).then(function () {
        vm.onCreate();
        vm.cancel();
      });
    }

    function updateSingleWashData(data) {
      pricingActions.updateSingeWash(data).then(function () {
        vm.onCreate();
        vm.cancel();
      });
    }

    function deleteSingleWashData(data) {
      pricingActions.deleteSingeWash(data.id).then(function () {
        vm.onCreate();
        vm.cancel();
      });
    }

    vm.editingSingleWash = function (singleWash) {
      vm.singleWashData = {
        id: singleWash.id,
        price: singleWash.price.amount
      };
      vm.buttonTitle = $translate.instant("UPDATE");
      vm.editSingleWash = true;
    };

    vm.deletingSingleWash = function (singleWash) {
      $scope.saveButtonClass = "custom-save-button-class";
      vm.singleWashData = {
        id: singleWash.id,
        price: singleWash.price.amount
      };
      vm.buttonTitle = $translate.instant("DELETE");
      vm.editSingleWash = false;
      vm.deleteSingleWash = true;
    };

    vm.cancel = function () {
      vm.singleWashData = {
        id: null,
        price: null
      };
      vm.buttonTitle = $translate.instant("SAVE");
      vm.editSingleWash = false;
      vm.deleteSingleWash = false;
      $scope.singleWashForm.$setUntouched();
      $scope.saveButtonClass = "md-primary";
    };

  }
})();
